import { message } from "antd";

export function findByXY(list, x, y) {
  let newRect = [];
  const index = list.findIndex((element) => {
    newRect = [...element.rect];
    return newRect[0] < x && newRect[2] > x && newRect[1] < y && newRect[3] > y;
  });
  return index;
}

export function getPageXy(e) {
  let x, y;

  if (e.pageX && e.pageY) {
    x = e.pageX;
    y = e.pageY;
  } else if (e.targetTouches[0]?.pageX && e.targetTouches[0]?.pageY) {
    x = e.targetTouches[0].pageX;
    y = e.targetTouches[0].pageY;
  } else if (e.changedTouches[0]?.pageX && e.changedTouches[0]?.pageY) {
    x = e.changedTouches[0].pageX;
    y = e.changedTouches[0].pageY;
  }

  return {
    pageX: x,
    pageY: y,
  };
}

export function convertXyToPdfPoints(e, pageContainer, currentPage) {
  const pageX = getPageXy(e).pageX;
  const pageY = getPageXy(e).pageY;

  let x = pageX - pageContainer.getBoundingClientRect().left - window.scrollX; // get x
  // let y = pageY - pageContainer.getBoundingClientRect().top; // get y
  let y = pageY - 60;

  let defaultScaleX, defaultScaleY;

  try {
    const defaultViewport = currentPage.getViewport({
      scale: 1,
    });

    [defaultScaleX, defaultScaleY] = defaultViewport.convertToPdfPoint(x, y);

    const pageScale = pageContainer.clientWidth / defaultViewport.width;

    const viewport = currentPage.getViewport({
      scale: pageScale,
    });

    [x, y] = viewport.convertToPdfPoint(x, y);
  } catch (e) {
    console.error(e);
    if (e.message) {
      message.error(e.message);
    }
  }

  return {
    x,
    y,
    defaultScaleX,
    defaultScaleY,
  };
}

export function getPdfViewPortBasedOnClientScreen(pageContainer, currentPage) {
  const defaultViewport = currentPage.getViewport({
    scale: 1,
  });

  const pageScale = pageContainer.clientWidth / defaultViewport.width;

  const viewport = currentPage.getViewport({
    scale: pageScale,
  });

  return viewport;
}

export function unit8ArrayToBlob(
  unit8Array,
  mimeType = "application/octet-stream"
) {
  const blob = new Blob([unit8Array], {
    type: mimeType,
  });
  // window.URL.createObjectURL()
  return blob;
}

export function downloadBlobFile(data) {
  const fileName = "my-download.pdf";

  let a = document.createElement("a");
  document.body.appendChild(a);
  a.style = "display: none";
  a.href = data;
  a.download = fileName;
  a.click();
}

export function handleScroll(clickHoldOptions) {
  if (clickHoldOptions.timeout_id && clickHoldOptions.timeout_id > 0) {
    clearInterval(clickHoldOptions.timeout_id);
  }
}
